import {
  IPetWellnessplanDetails,
  IWellnessPlanByPetObject,
  IWellnessPlanMembershipExistByPetIdResp,
  IWellnessPlanMembershipResponse,
}
  from "./wellness-plan.interface";
import { ApolloError, useLazyQuery, useQuery } from "@apollo/client";

import { GET_WELLNESSPLAN_BY_USER_AND_PET } from "./wellness-plan-by-petId.query";
import { GET_WELLNESS_PLAN_LIST } from "./wellness-plan-list.query";
import { WELLNESS_PLAN_EXIST_BY_PET_ID } from "./wellness-plan-exist.query";

export const useFetchWellnessPlan = () => {
  const { data, loading, error } = useQuery<{fetchWellnessPlan:
     IWellnessPlanMembershipResponse}>(GET_WELLNESS_PLAN_LIST);

  return {
    data: data?.fetchWellnessPlan,
    loading,
    error,
  };
};

export const useFetchWellnessPlanByPetId = () => {
  const [getWellnessplanByUserAndPet, { data, loading, error }] =
   useLazyQuery<IWellnessPlanByPetObject>(GET_WELLNESSPLAN_BY_USER_AND_PET);

  const getWellnessPlanByPetId =
    (petId: string,
      onCompleted?: (data: IPetWellnessplanDetails) => void,
      onError?: (error: ApolloError) => void) => {
      getWellnessplanByUserAndPet({
        variables: {
          petId,
        },
        fetchPolicy: "network-only",
        onCompleted: (raw: IWellnessPlanByPetObject) => {
          if (!raw.getWellnessplanByUserAndPet.success) {
            onError?.(new ApolloError({ errorMessage: raw.getWellnessplanByUserAndPet.messages }));
            return;
          }
          onCompleted?.(raw.getWellnessplanByUserAndPet.wellnessPlanByPet);
        },
        onError,
      });
    };

  // Return data if the query was successful
  const validData = data?.getWellnessplanByUserAndPet?.success ?
    data?.getWellnessplanByUserAndPet?.wellnessPlanByPet :
    undefined;

  return {
    getWellnessPlanByPetId,
    data: validData,
    loading,
    error: error ||
      (!data?.getWellnessplanByUserAndPet?.success &&
        data?.getWellnessplanByUserAndPet?.messages ?
        new Error(data.getWellnessplanByUserAndPet.messages) :
        undefined),
    success: data?.getWellnessplanByUserAndPet?.success,
  };
};


export const useCheckWellnessPlanExistByPetId = () => {
  const [checkWellnessPlanExistByPetId, { data, loading, error }] =
   useLazyQuery<{checkWellnessPlanExistByPetId:IWellnessPlanMembershipExistByPetIdResp}>(WELLNESS_PLAN_EXIST_BY_PET_ID);

  const checkWellnessPlanExist = (petId: string) => {
    checkWellnessPlanExistByPetId({
      variables: {
        petId,
      },
    });
  };

  return {
    checkWellnessPlanExist,
    data: data?.checkWellnessPlanExistByPetId,
    loading,
    error,
  };
};
